import { DateStruct } from "src/app/models/DatePickerModel";
import { Lookup } from "src/app/models/Lookup";

export class ListData {
  canAdd!: boolean;
  pageIndex!: number;
  totalCount!: number;
  pageSize!: number;
  pageData!: RestaurantDetails[];
  userType!: userType
}
export enum userType {
  Owner = 'RestaurantOwnerRole',
  Manager = 'RestaurantManagerRole'
}
export enum RestaurantType {
  Main = 'Main',
  Branch = 'Branch'
}
export class RestaurantDetails {
  branchNumber!: number
  canDelete!: boolean
  canEdit!: boolean
  city!: Lookup
  cityId!: number
  country!: Lookup
  countryId!: number
  created!: string
  icon!: string
  id!: number
  isSelected!: boolean
  name!: string
  isMain!: boolean
  mainRestaurant!: {
    icon: string
    name: string
  }
  isManager!: boolean
  latitude!: string
  longitude!: string
  mail!: string
  manager: any
  owner: any
  parintId!: number
  phoneNumber!: string
  phone!: string
  phoneCode!: string
  phoneflag!: string
  restaurantCuisine!: any[]
  restaurantType!: RestaurantType
  streetName!: string
  address_Ar!: string
  address_En!: string
  address!: string
  title_Ar!: string
  title_En!: string
  title!: string
  menusCount!: number
  branchManager!: Manager
  banner!: string
  shortName!: string;
  whatsappflag!: string
}

export class Manager {
  managerIcon!: string
  managerName!: string
}

export class ListFilter {
  pageSize!: number;
  pageNumber!: number;
  sortItems!: sortList;
  searchText!: string;
  createdFrom!: Date;
  createdTo!: Date;
  restaurantsType!: RestaurantType
  restaurantnumber!: number
  branchNumber!: number
}

export enum sortList {
  Name = 0,
  NewestCreate = 1,
  OldestCreate = 2,
  HighestUse = 4,
  LowestUse = 3
}

export class RestaurantForm {
  id!: number
  restaurantType!: RestaurantType
  parintId!: number
  icon!: string
  phoneflag!: string
  phoneCode!: string
  phone!: string
  mail!: string
  countryId!: number
  cityId!: number
  streetEn!: string
  streetAr!: string
  title_EN!: string
  title_AR!: string
  latitude!: string
  longitude!: string
  cuisines!: number[]
  owner!: RestaurantStuff | null
  isManager!: boolean
  manager!: RestaurantStuff | null
  whatsappflag!: string
  whatsappCode!: string
  whatsapp!: string
}
export class RestaurantStuff {
  fName!: string
  lName!: string
  phoneflag!: string
  phoneCode!: string
  phoneNumber!: string
  email!: string
  nationalityId!: number
  birthDate!: DateStruct
  gender!: string
  profilePhoto!: string
}

export class ReservationChannels {
  id!: number
  name!: string
  icon!: string
  isOnlineReservation!: boolean
  isOther!: boolean
  isSelected!: boolean
  checked?: boolean
  otherReservationvalue?: string
  otherValue?: string
}


export class RestaurantProfile {
  id!: number
  restaurantType!: RestaurantType
  parintId!: number
  isOpenNow!: boolean
  isPublish!: boolean
  mainRestaurant!: {
    icon: string
    name: string
  }
  icon!: string
  phone!: string
  phoneflag!: string
  phoneCode!: string
  mail!: string
  website!: string
  countryId!: number
  cityId!: number
  streetEn!: string
  streetAr!: string
  streetName!: string
  title_EN!: string
  title_AR!: string
  name!: string
  isManager!: boolean
  latitude!: string
  longitude!: string
  country!: Country
  city!: City
  restaurantCuisine!: {
    cuisineId: number
    restaurantId: number
    cuisine: Cuisine
  }[]
  owner!: RestaurantStuff
  manager!: RestaurantStuff
  canEdit!: boolean
  canReplaceManager!: boolean
  canDelete!: boolean
  branchNumber!: number
  created!: string
  visitor!: number
  staffNumber!: number
  rate!: number
  complainys!: number
  canViewCancellationPolicy!: boolean;
  canAddCancellationPolicy!: boolean;
  canEditCancellationPolicy!: boolean;
  canDeleteCancellationPolicy!: boolean;
  publishStatus!: any
  canLenkpublishStatus!: any
  shortName!: string
  showPublishButton!: boolean
  canPublish!: boolean
  canViewConfigSection!: boolean
  statistics!: { visits: number, rate: number, staff: number, complaints: number }
  vatNumber!: string
  menuQRCode!: string

  canShowOwnerManager!: boolean
  canShowShortCut!: boolean
  attandanceFeature!: boolean
  restaurantProfileLicense!: License

  canViewZatcaSection!: boolean
  restaurantZatcaConfiguration!: {
    isZatcaIntegrated: boolean
    zatcaConfigMode: string
    zatcaConfigrationType: string
    zatcaConfigrationdate: string
    zatcaSellerName: string
  }
}

export class Country {
  id!: number
  name!: string
  title_EN!: string
  title_AR!: string
}

export class City {
  id!: number
  name!: string
  title_EN!: string
  title_AR!: string
}

export class Cuisine {
  id!: number
  name!: string
  numberOfUse!: number
  title_AR!: string
  title_EN!: string
}

export class AmenitiesRestaurant {
  restaurantId!: number
  amenities!: {
    amenitiesId: number;
  }[]
}
export class AmenitiesLookup {
  id!: number
  name!: string
  title_EN!: string
  title_AR!: string
  icon!: string
  updated!: string
  isSelected!: boolean
  canSelect!: boolean
  canDelete!: boolean
}

export class AmenitiesObject {
  restaueantName!: string
  restaurantIngredientDtos!: AmenitiesLookup[]
}


export class DiwanSizes {
  restaurantsizeId!: number
  id!: number
  name!: string
  title_EN!: string
  title_AR!: string
  canDelete!: boolean
  isSelected!: boolean
  canSelect!: boolean
}

export class RestaurantSize {
  customSize!: CustomSize
  diwanSize!: number[]
  restaurantId!: number
}

export class CustomSize {
  restaurantSizeId!: number
  name!: {
    title_EN: string
    title_AR: string
  }
  sizeClassificationId!: number
} []


export enum AddManagerType {
  New,
  Old
}

export class Managers {
  icon!: string;
  name!: string;
  oldRestaurant!: string;
  restaurants!: string[];
  userId!: number;
}

export class RestaurantFilter {
  pageNumber!: number;
  pageSize!: number;
  searchText!: string;
  selectedId!: number;
}
export class RestaurantsData {
  pageData!: any[];
  pageNumber!: number;
  pageSize!: number;
  totalCount!: number;
}

export class License {
  startDate!: string;
  endDate!: string;
}
